import type { ConsumerConfig } from '../index';
import logo from './logo.svg';

/**
 * MGM Resorts consumer configuration.
 * Everything for MGM lives in this folder — logo, theme, config.
 *
 * Cannot import from idme-assets directly: it is a Rails gem with no npm exports.
 * All values below are sourced from:
 *   idme-assets/app/assets/stylesheets/themes/mgm/_colors.scss
 *   idme-assets/app/assets/stylesheets/themes/mgm/_base.scss
 *
 * CSS overrides live in mgm/theme.scss (--consumer-* vars under .theme-mgm).
 *
 * Font note: "Calibre" is a custom font used by MGM. Falls back to sans-serif
 * on platforms where it is not available.
 */
export const mgmConfig: ConsumerConfig = {
  themeClass: 'theme-mgm',
  logo: {
    src: logo,
    alt: 'MGM Resorts',
  },
  brand: {
    fontFamily: '"Calibre R Regular", sans-serif',                              // $calibre in _fonts.scss
    colorPrimary: 'linear-gradient(225deg, #373AE5 14.64%, #292CB7 50%)',       // .btn.btn-primary in _buttons.scss
    colorTextPrimary: '#00012B',                                                // $primary in _colors.scss
    colorTextSecondary: '#74767C',                                              // $secondary in _colors.scss
  },
};
